<template>
  <div class="footer">
    <Header @save="saveOptions" />
    <div class="content-wrap">
      <GeneralSettingsEnableFooter
        :isEnabled="!!footerData.enable_footer.value"
        @enableFooter="handleEnableFooter"
      />
      <GeneralSettingsFooterLayout
        :selectedColumnSet="footerData.footer_layout.value"
        @selectedColumnSet="handleSelectedColumnSet"
      />
      <div class="accordion-widget">
        <div class="accordion-wrap">
          <GeneralSettingsAccordion
            v-for="(el, key, idx) in columnValues"
            :key="idx"
            :idx="idx"
            :valueObj="el"
            :draggingObject="draggingObject"
            @save="handleColumnValue($event, idx)"
            @droppedAt="handleDroppedAt"
          />
        </div>
        <GeneralSettingsWidgetSelector
          v-if="selectedColumnSet"
          @isDragging="handleIsDragging"
        />
      </div>
      <GeneralSettingsScrollToTop
        :isChecked="!!footerData.scroll_to_top.value"
        @scrollToTop="handleScrollToTop"
      />
      <ColorSettings :colors="footerData.color" @emitColor="handleEmitColor" />
      <PreCopyrightNavigation
        @preCopyright="handlePrecopyright"
        :navData="footerData.pre_copyright_navigation"
      />
      <CopyrightLine
        :copyrightLine="footerData.copyright_line.value"
        @copyrightLine="handleCopyrightLine"
      />
      <ReportBug :data="footerData.report_a_bug" @reportBug="handleReportBug" />
      <SocialMediaLinks
        :data="footerData.social_media"
        @socialNetwork="handleSocialNetwork"
        @socialMediaLabel="socialMediaLabel"
      />
      <TogglePartnerLogos
        :isChecked="!!footerData.partner_logo_enabled.value"
        @togglePartnerLogos="handleTogglePartnerLogos"
      />
      <PartnerLogosLayout
        :logosObj="footerData.partner_logos"
        @selectedColumnSet="handlePartnerLogosSelectedColumnSet"
        @partnerLogoSettings="handlePartnerLogoSettings"
        @partnerLogoImage="handlePartnerLogoImage"
        @dataChange="handleDataChange"
      />
      <PoweredBy
        @footerImage="poweredByImage"
        @togglePoweredBy="handleTogglePoweredBy"
        @poweredByLabel="handlePoweredByLabel"
        @poweredByDomain="handlePoweredByDomain"
        @poweredByMars="handlePoweredByMars"
        :footerData="footerData"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Header from './DynamicFooterComponents/Header.vue'
import GeneralSettingsEnableFooter from './DynamicFooterComponents/GeneralSettingsEnableFooter.vue'
import GeneralSettingsFooterLayout from './DynamicFooterComponents/GeneralSettingsFooterLayout.vue'
import GeneralSettingsAccordion from './DynamicFooterComponents/GeneralSettingsAccordion.vue'
import GeneralSettingsWidgetSelector from './DynamicFooterComponents/WidgetSelector.vue'
import GeneralSettingsScrollToTop from './DynamicFooterComponents/GeneralSettingsScrollToTop.vue'
import ColorSettings from './DynamicFooterComponents/ColorSettings.vue'
import PreCopyrightNavigation from './DynamicFooterComponents/PreCopyrightNavigation.vue'
import CopyrightLine from './DynamicFooterComponents/CopyrightLine.vue'
import ReportBug from './DynamicFooterComponents/ReportBug.vue'
import SocialMediaLinks from './DynamicFooterComponents/SocialMediaLinks.vue'
import TogglePartnerLogos from './DynamicFooterComponents/TogglePartnerLogos.vue'
import PartnerLogosLayout from './DynamicFooterComponents/PartnerLogosLayout.vue'
import PoweredBy from './DynamicFooterComponents/PoweredBy.vue'
export default {
  components: {
    Header,
    GeneralSettingsEnableFooter,
    GeneralSettingsFooterLayout,
    GeneralSettingsAccordion,
    GeneralSettingsScrollToTop,
    ColorSettings,
    GeneralSettingsWidgetSelector,
    PreCopyrightNavigation,
    CopyrightLine,
    ReportBug,
    SocialMediaLinks,
    TogglePartnerLogos,
    PartnerLogosLayout,
    PoweredBy,
  },
  data() {
    return {
      selectedColumnSet: null,
      draggingType: null,
      draggingObject: {},
      footerData: {
        enable_footer: {
          value: 1,
        },
        columns: {
          footer_column_1: {},
          footer_column_2: {},
          footer_column_3: {},
          footer_column_4: {},
          footer_column_5: {},
        },
        footer_layout: {},
        scroll_to_top: {
          value: 1,
        },
        color: {
          background: '',
          icon_color: '',
          links_color: '',
          text_color: '',
          powered_by_color: '',
        },
        pre_copyright_navigation: {
          value: [],
        },
        copyright_line: {},
        social_media: {},
        partner_logo_enabled: {
          value: true,
        },
        partner_logos: {
          data: [],
        },
        powered_by: {
          mars_enabled: true,
          image: '',
          label: '',
          url: '',
        },
        report_a_bug: {
          enabled: true,
          label: '',
          url: '',
        },
      },
    }
  },
  computed: {
    columnValues() {
      return Object.keys(this.footerData.columns)
        .slice(0, this.selectedColumnSet)
        .reduce((result, key) => {
          result[key] = this.footerData.columns[key]
          return result
        }, {})
    },
  },
  mounted() {
    this.getFooterConfig()
  },
  methods: {
    handleTogglePoweredBy(bool) {
      this.footerData.powered_by.enabled = bool
      console.log(this.footerData)
    },
    handleDroppedAt(idx) {
      this.draggingObject = {
        type: this.draggingType,
        idx: idx,
      }
    },
    handleIsDragging(type) {
      this.draggingType = type
    },
    handlePoweredByLabel(str) {
      this.footerData.powered_by.label = str
    },
    handlePoweredByDomain (str) {
      this.footerData.powered_by.url = str;
    },
    handlePoweredByMars (bool) {
      this.footerData.powered_by.mars_enabled = bool;
    },
    poweredByImage(obj) {
      console.log(obj)
      this.footerData.powered_by.image = obj.image
      this.footerData.powered_by.url = obj.url
    },
    handlePartnerLogoImage(obj) {
      this.footerData.partner_logos.data[obj.index].image = obj.image
    },
    handleDataChange(data) {
      const dataCopy = JSON.parse(JSON.stringify(data))
      this.footerData.partner_logos.data = dataCopy.map((el) => {
        return {
          image: el.img,
          url: el.domain,
          width: el.width,
          height: el.height,
        }
      })
    },
    handlePartnerLogoSettings(payload) {
      let keys = Object.keys(payload)
      for (const i of keys) {
        this.footerData.partner_logos[i] = payload[i]
      }
    },
    handlePartnerLogosSelectedColumnSet(payload) {
      const plObj = this.footerData.partner_logos
      this.footerData.partner_logos = {
        ...plObj,
        layout: payload === 8 ? 'grid' : 'carousel',
      }
    },
    handleTogglePartnerLogos(payload) {
      this.footerData.partner_logo_enabled = { value: payload }
    },
    socialMediaLabel(payload) {
      this.footerData.social_media.label = payload
    },
    handleSocialNetwork(payload) {
      let networkName = payload.networkName.toLowerCase()
      this.footerData.social_media[networkName] = payload.url
    },
    handleReportBug({ key, value }) {
      this.footerData.report_a_bug[key] = value
    },
    handleCopyrightLine(payload) {
      this.footerData.copyright_line = { value: payload }
    },
    handlePrecopyright(payload) {
      let formattedArr = []
      payload.forEach((element) => {
        console.log(payload)
        formattedArr.push({
          label: element.terms,
          url: element.domain
        })
      })
      if (formattedArr[formattedArr.length - 1] == { label: '', url: '' })
        formattedArr.splice(-1, 1)
      this.footerData.pre_copyright_navigation = { value: formattedArr }
    },
    handleEmitColor(payload) {
      if (payload.idx == 0) {
        this.footerData.color.background = payload.value
      }
      if (payload.idx == 1) {
        this.footerData.color.text_color = payload.value
      }
      if (payload.idx == 2) {
        this.footerData.color.links_color = payload.value
      }
      if (payload.idx == 3) {
        this.footerData.color.icon_color = payload.value
      }
      if (payload.idx == 4) {
        this.footerData.color.powered_by_color = payload.value
      }
    },
    handleEnableFooter(payload) {
      this.footerData.enable_footer = { value: payload }
    },
    handleSelectedColumnSet(payload) {
      this.selectedColumnSet = payload
      this.footerData.footer_layout = { value: payload }
    },
    handleScrollToTop(payload) {
      this.footerData.scroll_to_top = { value: payload }
    },
    handleColumnValue(payload, idx) {
      const columnKeys = Object.keys(this.columnValues)
      const columnKeyToUpdate = columnKeys[idx]
      this.footerData.columns[columnKeyToUpdate] = payload
    },
    async getFooterConfig() {
      try {
        const res = await api.getFooterConfig()
        this.footerData = res.data.footer
        localStorage.setItem('initialColumnSet',this.footerData.footer_layout.value)
      } catch (error) {
        console.log(error)
      }
    },
    async saveOptions() {
      try {
        const res = await api.postFooterConfig({
          data: JSON.stringify(this.footerData),
        })
        this.EventBus.$emit('info', {
          message: 'Options saved!'
        })
      } catch (error) {
        console.log(error)
        this.EventBus.$emit('error', {
          message: 'Something went wrong.'
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}
.footer {
  overflow-y: auto;
  background-color: #f4f5f7;
  .content-wrap {
    margin: 25px 15px;
    padding: 15px 25px;
    background: #fff;
    min-height: 600px;
    .accordion-widget {
      display: flex;
      .accordion-wrap {
        max-width: 1100px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
      }
    }
  }
}
</style>
